import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";

export const Spacer = styled.div<SpaceProps>`
    ${space};
`;

export default Spacer;
